import { OriginationTracking, getOriginationFromUrl } from '@applyonline/shared'

import { createContext, useContext, useMemo, useState } from 'react'
import { getIdsFromUrl } from '../services/query-string'


export interface TAppStore {
  merchantId: string
  setMerchantId: (id: string) => void
  originationFromUrl: OriginationTracking | null
}

export const AppContext = createContext<TAppStore | null>(null)

export function useAppStoreProvider() {
  const idsFromUrl = getIdsFromUrl()
  const [merchantId, setMerchantId] = useState<string>(idsFromUrl.merchantId)
  const [originationFromUrl] = useState<OriginationTracking | null>(getOriginationFromUrl(window.location.search))

  return useMemo(
    () => ({
      merchantId,
      setMerchantId,
      originationFromUrl,
    }),
    [merchantId, setMerchantId, originationFromUrl],
  )
}

export function useAppStore(): TAppStore {
  return useContext(AppContext)!
}
